module.exports = __webpack_public_path__ + "img/2.74e637d1.png";